// One source of idempotency keys for tRPC mutations. Every snooze /
// markPassed / markExecuted / signals.createManual call passes a key so
// retrying a request after a network blip never double-applies.
//
// crypto.randomUUID() is available in every modern browser (and required
// in the API contract — `z.string().uuid()`).
export function newIdempotencyKey(): string {
  return crypto.randomUUID();
}
